import Subject from 'common/src/utils/pubsub/subject';
import {SlimUserWithRoles, User} from '../../users/users.types';
import {CLPromiseRef} from '../shared.types';

const userPromise: CLPromiseRef<User> = {current: null};

const usersByIdsPromise: CLPromiseRef<SlimUserWithRoles[]> = {current: null};

const userSubject = new Subject<User>(null);

export {userPromise, userSubject, usersByIdsPromise};
